<template>
   <div class="bg-secondary text-light cc-style">
      <div class="row">
         <div class="col-10">
            <h5 class="ms-2">CheckList CRUD</h5>
         </div>
         <button class="btn btn-sm btn-dark col-1"
               type="button" 
               @click="changeOrderBy()"
         >
            Orden
         </button>
         <button class="btn btn-sm btn-dark col-1"
               type="button" 
               @click="addNew()"
         >
            Nuevo
         </button>
      </div>
      <ul class="list-group">
         <li   v-for="(checkList, index) in checkLists" :key="index"
               class="list-group-item list-group-item-action list-group-item-dark"
         >
            <div class="row">
               <div class="col-1">
                  {{checkList.id}}
               </div>
               <div  class="col-1"
               >
                  <button  type="button" 
                           class="btn btn-secondary btn-sm" 
                           data-bs-toggle="modal" 
                           data-bs-target="#controlsModal"
                           :data-check-list-id="checkList.id"
                  >
                     {{checkList.controls}}
                  </button>
               </div>
               <div  class="col-10"
                     @click="upName(checkList)"
               >
                  {{checkList.name}}
               </div>
            </div>
         </li>
      </ul>
   </div>

<!-- Modal -->
<div class="modal fade" id="controlsModal" tabindex="-1" aria-labelledby="controlsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="controlsModalLabel">CheckList ID: {{checkListId}}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         <ul class="list-group">
            <li   v-for="(control, index) in clControls" :key="index"
                  class="list-group-item list-group-item-action list-group-item-dark px-4"
            >
               <div class="row">
                  <div class="col-1">
                     {{control.wspControl.id}}
                  </div>
                  <div  class="col-1">
                     <div v-if="control.wspControl.type">
                        {{control.wspControl.type}}
                     </div>
                     <div v-else>
                        --
                     </div>
                  </div>
                  <div  class="col-7">
                     {{control.wspControl.name}}
                  </div>
                  <div  class="col-1"
                  >
                     <button  type="button" 
                              class="btn btn-secondary btn-sm" 
                              @click="orderCheckList(checkListId, control.wspControl.id, 1)"
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>
                        </svg>
                     </button>
                  </div>
                  <div  class="col-1 text-center">
                     {{control.order}}
                  </div>
                  <div  class="col-1"
                  >
                     <button  type="button" 
                              class="btn btn-secondary btn-sm" 
                              @click="orderCheckList(checkListId, control.wspControl.id, -1)"
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                        </svg>
                     </button>
                  </div>
               </div>
            </li>
         </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Salir</button>
        <button   type="button" 
                  class="btn btn-primary"
                  @click="adControls()"
         >
            Alta/Baja
         </button>
        <button   type="button" 
                  class="btn btn-primary"
                  @click="orderCheckList(checkListId, 0, 0)"
         >
            Ordenar por ID
         </button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
//import { ref, onMounted, watch, computed, nextTick } from 'vue';
import { ref, onMounted } from 'vue';

import WspService from "/src/modules/workSpace/workSpace.service"; //src\modules\workSpace\workSpace.service.js

export default {
   setup() {
      const checkLists = ref([])
      const byAsc = ref(false)
      const checkListId = ref(0)
      const clControls = ref([])

      onMounted(() => {
         document.getElementById('controlsModal')
         .addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget
            checkListId.value = Number(button.getAttribute('data-check-list-id'))
            getControlsByCheckList(checkListId.value)
         })
         byAsc.value = false
         getCheckLists('desc')
      })

      function adControls() {
         let adControlId = prompt('ID control: ')
         if (adControlId != null) {
            WspService.adControl(checkListId.value, adControlId).then(
               (response) => {
                  if (!response.data) {
                     alert('El ID: ' + adControlId + ' no es válido!')
                  } else {
                     getControlsByCheckList(checkListId.value)
                     getcheckListsBy()
                  }
               },
               (error) => {
                  console.log(error.status);
                  alert('El ID: ' + adControlId + ' no es válido!')
               }
            );
            //upCheckList(chkl.id, upName)
            //adControl(checklistId, controlId)
         }
      }

      function addNew() {
         upCheckList(0, null)
      }

      function changeOrderBy() {
         byAsc.value = !byAsc.value
         getcheckListsBy()
      }

      function getcheckListsBy() {
         if (byAsc.value) {
            getCheckLists('asc')
         } else {
            getCheckLists('desc')
         }
      }

      function getCheckLists(ascDesc) {
         WspService.getCheckLists(ascDesc).then(
            (response) => {
               checkLists.value = response.data;
            },
            (error) => {
               console.log(error.status);
            }
         );
      }

      function orderCheckList(chkListId, ctrolId, upDown) {
         WspService.orderCheckList(chkListId, ctrolId, upDown)
         .then(
            () => { getControlsByCheckList(checkListId.value) }
         )
         .catch(error => {
            console.log(error);
         });
      }

      function upControls(id) {
         upCheckList(id, null)
      }

      function upName(chkl) {
         let upName = prompt('ID checkList: ' + chkl.id, chkl.name)
         if (upName != null) {
            upCheckList(chkl.id, upName)
         }
      }

      function upCheckList(id, name) {
         WspService.upCheckList(id, name)
         .then(
            () => { getcheckListsBy() }
         )
         .catch(error => {
            console.log(error);
         });
      }

      function getControlsByCheckList(chLiId) {
         WspService.getControlsByCheckList(chLiId).then(
            (response) => {
               clControls.value = response.data;
            },
            (error) => {
               console.log(error.status);
            }
         );
      }

      return {
         checkLists,
         changeOrderBy,
         upControls,
         addNew,
         upName,
         checkListId,
         clControls,
         adControls,
         orderCheckList
      }
   },
}
</script>

<style scoped>
.cc-style {
   height: auto;
}
</style>
